import { styled } from 'linaria/react';

export const StepHeader = styled('div')`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    width: 100%;
    position: relative;
    margin: 0 auto 2rem;
    height: 35px;
    z-index: 1;
  @media screen and (max-width: 800px) {
    margin: 1rem 0 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  @media screen and (max-width: 600px) {
    height: 50px;
  }
  `